"use client";
import { cva as a } from "class-variance-authority";
const t = a("", {
  variants: {
    slot: {
      content: [
        "flex flex-col bg-white dark:bg-gray-dark-800",
        "rounded-md z-popover",
        "shadow-md relative",
        "data-[state=open]:animate-fade-in",
        "data-[state=closed]:animate-fade-out"
      ],
      arrow: "fill-white dark:fill-gray-dark-800"
    }
  }
});
export {
  t as popover
};
